import { render, staticRenderFns } from "./punch-dialog.vue?vue&type=template&id=58cc1d60&"
import script from "./punch-dialog.vue?vue&type=script&lang=js&"
export * from "./punch-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports